<template lang="pug">
  .page.page_offset_top.page_offset_bottom
    .page-meta
      .container
        .page-meta__inner.page-meta__inner_top
          breadcrumbs
          social.page-meta__social-list(theme="blue")
    .page-news-inner
      .container
        h1.title.title_size_l.text_center.page-news-inner__title BelkaCar начинает работать в Сочи
        .jumbotron.page-news-inner__jumbotron
          .jumbotron__image
            img(src="/static/img/news-inner-img.jpg", alt="")
          .jumbotron__content
            time.news-card-item__date 27 августа 2018
            .news-article.text_theme_gray
              p Основатели крупнейшего российского каршеринга BelkaCar объявили о запуске сервиса в Сочи. С 12 июля 2018 года премиальный сервис BelkaBlack станет доступен в Большом Сочи, а также в Красной Поляне и горном курорте «Роза Хутор». Для удобства туристов в аэропорту Сочи для BelkaCar создано собственное парковочное пространство.
              p В первый день на рынок будут выведены 75 Mercedes-Benz GLA. Аренда автомобилей будет начинаться от 14 руб/мин и 5 000 руб в сутки. Обычного тарифа BelkaCar и опции льготного ночного ожидания в Сочи пока не планируется.
              p "Сочи - в некотором смысле уникальный город. С одной стороны, очень большая доля туристов приезжает сюда из Москвы и уже имеет опыт использования каршеринга, а с другой — общественный транспорт в городе развит меньше, чем в столице, что делает его более привлекательным для запуска каршеринга. По нашим данным, рынок Сочи сегодня можно оценить в 1000 автомобилей по нижней границе. Верхнюю границу назвать очень сложно, так как в премиум-сегменте представлены только компании по классической аренде авто, а сам рынок очень фрагментирован и подвержен сезонности. Сейчас мы запускаем BelkaBlack на небольшое количестве автомобилей, чтобы протестировать сервис и понять потенциал спроса. После чего будем расширять парк", — сообщили основатели сервиса.
              p Несколько недель назад мобильное приложение BelkaCar было признано лучшим по мнению исследовательской лаборатории информационных продуктов Роскачества. Специалисты назвали приложение BelkaCar наиболее удобным в пользовании, простым и качественным в навигации, а также отметили адаптированность для использования иностранцами.
      section.about-company-section.page-news-inner__about-company-section
        .container
          .page-mediacenter__container
            h2.title.title_size_l.text_center.about-company-section__title О компании BelkaCar
            p.text_theme_gray.about-company-section__text BelkaCar — каршеринговый сервис для краткосрочной аренды автомобиля через мобильное приложение. Сервис работает по концепции «все включено»: оплата парковки, бензина и страховки уже включены в стоимость услуги.
            p.text_theme_gray.about-company-section__text BelkaCar работает как с частными, так и с корпоративными клиентами. Главная ценность компании — это технологичность. Собственная IT-платформа оперативно подберет ближайший автомобиль и максимально упростит процесс использования сервиса, разрешив любые возникающие вопросы.
      section.contacts-pressa-section.page-news-inner__contacts-pressa-section
        .container
          .page-mediacenter__container
            h2.title.title_size_l.text_center.contacts-pressa-section__title Контакты для прессы
            .contacts-pressa-section__row
              .contacts-pressa-section__col
                h3.contacts-pressa-section__name Екатерина Макарова
                p.contacts-pressa-section__contacts
                  a(href="tel:+7 (903) 191-34-85") +7 (903) 191-34-85
                  a(href="mailto:emakarova@belkacar.ru") emakarova@belkacar.ru
              .contacts-pressa-section__col
                h3.contacts-pressa-section__name Алексей Скорик
                p.contacts-pressa-section__contacts
                  a(href="tel:+7 (903) 191-34-85") +7 (962) 933-30-99
                  a(href="mailto:emakarova@belkacar.ru") skorik@vincipr.com
</template>

<script>
import Social from './../components/Social'

export default {
  name: 'News',
  components: { Social },
  data () {
    return {}
  }
}
</script>



// WEBPACK FOOTER //
// src/views/NewsInner.vue